import React, {useContext, useState, useEffect} from 'react';
import "./index.css"
import RoomService from "../../service/RoomService";
import {Alert} from "react-bootstrap";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import ErrorComponent from '../../components/UI/Error/ErrorComponent';
import {fillTextPage} from "../../Utils/FillTextPage";
import {useNavigate} from "react-router-dom";
import Spin from '../../components/UI/Spin/Spin';
import Timer from "../../components/Timer/Timer"
import axios from 'axios';
import {format, addHours} from 'date-fns';
import {NAME_HOST_GAME} from "../../Utils/NAME_HOST";
import InfTour from "../../components/UI/InfTour/InfTour";
import Footer from "../../components/Footer/Footer";

const EnterRoom = () => {
    const {store} = useContext(Context)
    const [room, setRoom] = useState("");
    const [checkTourReg, setCheckTourReg] = useState(false);
    const [loadCheck, setLoadCheck] = useState(true)
    const [statusErrorChange, setStatusErrorChange] = useState(false);
    const [rooms, setRooms] = useState([])
    const navigate = useNavigate();
    const [status_load, setStatus_load] = useState(0)
    const [initialTime, setInitialTime] = useState(null)
    const [initialTimeReg, setInitialTimeReg] = useState(null)
    const [showRooms, setShowRooms] = useState(false)
    const [serverTime, setServerTime] = useState(true);
    const [authChecked, setAuthChecked] = useState(false)
    const getServerTime = async () => {
        try {
            const time_response = await RoomService.getTimeTour();
            if (time_response.data) {
                setInitialTime(time_response.data.initialTime)
                setInitialTimeReg(time_response.data.initialTimeReg)
            }
        } catch (e) {
            console.log(e)
        }


    }

    function formatCurrency(amount) {
        const currency = 'RUB';

        const formatter = new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: currency,
        });

        const formattedAmount = formatter.format(amount);

        return formattedAmount.replace(",00", '')
    }

    const fetchRooms = async () => {
        try {


            const response = await RoomService.getRooms_free()
            if (response.status === 200) {
                setRooms(response.data.rooms)
                // console.log(response.data.rooms)
                setShowRooms(true)
            } else {
                store.add_message("error1", ErrorComponent)

                setStatusErrorChange(!statusErrorChange)
            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)


            setStatusErrorChange(!statusErrorChange)


        } finally {
            setShowRooms(true)
        }
    }
    // Получить серверное время с помощью API
    useEffect(() => {
        const checkStatus = async () => {
            const resp = await RoomService.check_status_game();

            if (resp.data.on) {
                setStatus_load(1)

            } else {
                store.add_message("error2", ErrorComponent)


                setStatusErrorChange(!statusErrorChange)

            }

        }
        fillTextPage("free_rooms", store)
        getServerTime()
        checkStatus()

        checkTour()
        fetchRooms()
    }, []);
    // useEffect(() => {
    //
    //     if (error.length>0){
    //         store.add_message(error,ErrorComponent)
    //     }
    // }, [statusErrorChange]);
    useEffect(() => {
        if (store.isAuth) {
            setAuthChecked(true);
            if (store.user.status_admin === 1) {


            }
        }

    }, [store.isAuth])

    async function checkTour() {
        try {


            const response = await RoomService.checkTourReg();
            if (response.data) {
                setLoadCheck(false)
            }
            if (response.data.message === "yes") {
                setCheckTourReg(true)

            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)

            setStatusErrorChange(!statusErrorChange)


        }


    }

    const dateObject = new Date(Date.parse(serverTime));

// Создаем новый объект Date, чтобы не изменять исходную дату
//     if (!serverTime && !loadCheck){
//         navigate("/enter_room_free")
//     }
    if (loadCheck || !initialTime || !initialTimeReg) {

        return (
            <>

                {<Spin/>}

            </>
        )
    }


    // const timeDifference = Math.floor((Date.parse(UtcDate)-Date.parse(serverTime)) / 1000);
    //
    // const initialTime = timeDifference;
    // const initialTimeReg = Math.floor((Date.parse(enterDate)-Date.parse(serverTime)) / 1000);
    async function goToRoom(name) {
        try {


            const roomData = await RoomService.findRoomFreeData(name);
            if (roomData.data.message === "not_found_room") {
                store.add_message("error4", ErrorComponent)

                setStatusErrorChange(!statusErrorChange)


            }
            if (roomData.data.message === "ok") {
                window.location.replace(NAME_HOST_GAME + "/game")
            }
            if (roomData.data.message === "not_found_user") {
                navigate("")
            }
            if (roomData.data.message === "room_full") {
                store.add_message("error5", ErrorComponent)


                setStatusErrorChange(!statusErrorChange)

            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)


            setStatusErrorChange(!statusErrorChange)


        }
    }

    function updateRooms() {
        setShowRooms(false)
        fetchRooms()
    }

    async function fetchData(e) {
        e.preventDefault();
        try {


            const roomData = await RoomService.findRoomFreeData(room);
            if (roomData.data.message === "not_found_room") {
                store.add_message("error4", ErrorComponent)


                setStatusErrorChange(!statusErrorChange)


            }
            if (roomData.data.message === "ok") {
                window.location.replace(NAME_HOST_GAME + "/game")
            }
            if (roomData.data.message === "not_found_user") {
                navigate("")
            }
            if (roomData.data.message === "room_full") {
                store.add_message("error5", ErrorComponent)


                setStatusErrorChange(!statusErrorChange)

            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)


            setStatusErrorChange(!statusErrorChange)


        }
    }

    async function handleFreeRoom() {
        try {


            const roomData = await RoomService.findRoomFreeData("");
            if (roomData.data.message === "ok") {
                window.location.replace(NAME_HOST_GAME + "/game")
            }
            if (roomData.data.message === "not_found_user") {
                navigate("")
            }
            if (roomData.data.message === "room_full") {
                store.add_message("error5", ErrorComponent)


                setStatusErrorChange(!statusErrorChange)

            }
            if (roomData.data.err) {
                store.add_message(roomData.data.err, ErrorComponent)


                setStatusErrorChange(!statusErrorChange)

            }
        } catch (e) {
            store.add_message("error1", ErrorComponent)


            setStatusErrorChange(!statusErrorChange)


        }
    }

    if (!status_load) {
        return (
            <>

                {<Spin/>}
            </>
        )
    }
    if (authChecked) {
        if (store.isLoading || !showRooms) {
            return (
                <Spin/>
            )
        }
        if (!store.isLoading && store.user.login) {

            return (
                <>

                    <div>

                        <div className="container_enter">
                            {/*{store.user.status_admin===1?(*/}
                            

                            {/*):null}*/}


                            <div className="cover">
                                <h1>{store.dataLang["enter_name_room"]}</h1>
                                <form className="flex-form">
                                    {/*<label htmlFor="from">*/}
                                    {/*    <i className="ion-location"></i>*/}
                                    {/*</label>*/}
                                    <input onChange={e => setRoom(e.target.value)} type="search"

                                           placeholder={store.dataLang["placeholder_enter_room"]}/>
                                    <input onClick={fetchData} type="submit" value={store.dataLang["value_search"]}/>
                                </form>
                                <button onClick={handleFreeRoom}
                                        className="btn_quick_start">{store.dataLang["btn_quick_start"]}
                                </button>
                                <div className="ico">
                                    <i className="fa fa-refresh" style={{cursor: "pointer"}} aria-hidden="true"
                                       onClick={updateRooms}></i>

                                </div>

                            </div>
                            <div className="content_table">
                                {showRooms ? (
                                    <table className={showRooms ? "fade" : ""}>
                                        <thead>
                                        <tr>
                                            <th>{store.dataLang["th_name_room"]}
                                            </th>
                                            <th>{store.dataLang["th_name_count"]}</th>
                                            <th>{store.dataLang["th_name_action"]}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {rooms.map((room) => (
                                            <tr key={room.id}>
                                                <td>{room.name}</td>
                                                <td>
                                                <span className={`online`} name={room.name}>
                                                    {room.online}
                                                    <span
                                                        className={room.online < 30 ? "pulse-circle" : "pulse-circle red"}></span>
                                                </span>
                                                </td>
                                                <td>
                                                    <button className="buttonConnect"
                                                            onClick={() => goToRoom(room.name)}>{store.dataLang["buttonConnect"]}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                ) : null
                                }
                            </div>

                        </div>
                    <Footer/>
                    </div>
                </>
            );
        }
        if (!store.isLoading && !store.user.login) {
            return (
                <>
                    {<Spin/>}

                </>
            )
        }
    }

};

export default observer(EnterRoom);